/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-29 11:16:34
 * @LastEditors: linxi
 * @LastEditTime: 2025-01-14 15:36:21
 */

import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Checkbox, Col, Form, message, Modal, Row } from 'antd'
import React, { forwardRef, ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import styles from '../appointment.module.css'
// import { cancelInvoiceAsync, getInvoicingStatusAsync, invoicePageAsync, redeliveryAsync } from '..//confirm/paymentConfirmSlice'
import { AGColumns, AGToothColumns, Columns, ToothColumns } from './columns'
import { Query } from './Query'
import { traceRoute } from '../../../layouts/layoutSlice'
import {
  appointmentListAsync,
  cancelAppointmentAsync,
  selectBtnLoading,
  sendAppointmentSmsAsync,
  setBtnLoading,
  sureAppointmentAsync,
} from '../appointmentSelice'
import { useHistory, useLocation } from 'react-router-dom'
import { setAppointmentIdSlice } from '../../registration/register/registerSlice'
import { DateRangeType, getDateRange } from '../../../compnents/form/DateSelect'
import { AppointmentDetail } from './detail'
import { AddEditAppointment } from '../addEditAppointment'
import { AppointmentRegister } from '../../registration/register/appointmentRegister'
import { selectEdition } from '../../../app/applicationSlice'
import { RegisteredModal } from '../../A-toothModule/toothHome/modal/registeredModal'
import moment from 'moment'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../transactionQuery/transactionQuerySlice'
import { getSortColumnList } from '../../../models/common'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { SmsRechargeModal } from '../../home/smsRechargeModal'
interface AppointmentListProps {
  status?: number
  type?: number //口腔 his版 预约
  onLeftCount?: (obj: any) => void //口腔 his版 预约
  patientId?: string // 患者管理进入
  name?: any
  // onlyThisAccount?: any
  activeKey?: any
  toothPatient?: any
  SYCKHRSJHData?: boolean // 首页查看患者手机号权限
  SYCKHZSFZHData?: boolean // 首页查看患者身份证号权限
}

const AppointmentList = ({
  status,
  type,
  onLeftCount,
  patientId,
  name,
  // onlyThisAccount,
  activeKey,
  toothPatient,
  SYCKHRSJHData,
  SYCKHZSFZHData,
}: AppointmentListProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const history = useHistory()

  const location = useLocation()

  const [form] = Form.useForm()

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
    state: status,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [reasonModal, setReasonModal] = useState(false)

  const [appointmentDetailModal, setAppointmentDetailModal] = useState(false) //预约详情弹窗

  const [visibleTag, setVisibleTag] = useState('false')

  const [failReason, setFailReason] = useState('')

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [detailId, setDetailId] = useState('') //   预约详情 ID

  const [toothEditAppointmentMoal, setToothEditAppointmentMoal] = useState(
    false
  ) //  修改预约弹窗

  const [tableEditId, setTableEditId] = useState('') // 修改 ID
  const [tableEditPatientId, setTableEditPatientId] = useState('') // 修改 patientID

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const pageLoading = useSelector(selectBtnLoading)

  const [registeredModal, setRegisteredModal] = useState(false) //挂号弹窗

  const [detailVisible, setDetailVisible] = useState(false) //详情弹窗

  const [visibleTags, setVisibleTags] = useState('false')

  const [loading, setLoading] = useState(false)

  const [sureVisible, setSureVisible] = useState(false)

  const [sureData, setSureData] = useState<any>({})

  const [checked, setChecked] = useState(false)

  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'name',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'sex',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'ageYear',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '手机号',
      field: 'phone',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '预约时间',
      field: 'appointmentDate',
      minWidth: 190,
      visible: true,
    },
    {
      headerName: '预约科室',
      field: 'appointmentDepartmentName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '预约方式',
      field: 'appointmentType',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '预约医生',
      field: 'appointmentDoctorName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '接诊类型',
      field: 'furtherConsideration',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '预约项目',
      field: 'appointmentItem',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '短信状态',
      field: 'smsSendFlg',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '发送短信',
      field: 'sendSms',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '预约备注',
      field: 'appointmentComment',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '创建时间',
      field: 'createTime',
      minWidth: 170,
      visible: true,
    },
    {
      headerName: '状态',
      field: 'appointmentState',
      width: 120,
      minWidth: 120,
      pinned: 'right',
      lockPosition: "right",
      // flex: 1,
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 280,
      minWidth: 280,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  // 预约查看患者手机号数据权限
  const [YYCKHZSJHData, setYYCKHZSJHData] = useState<any>(true) //预约查看患者手机号数据权限

  // 预约查看患者身份证号数据权限
  const [YYCKHZSFZHData, setYYCKHZSFZHData] = useState<any>(true) //预约查看患者身份证号数据权限

  const [smsRechargeVisible, setSmsRechargeVisible] = useState(false) // 短信充值弹窗

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'appointmentList',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'appointmentList',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据

        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        dispatch(setBtnLoading(false))
      })
  }

  const column: any = toothPatient ? AGToothColumns : AGColumns

  useEffect(() => {
    setAllColumnList(allData)
  }, [])

  useEffect(() => {
    if (appointmentDetailModal) {
      setVisibleTag('true')
    } else {
      setVisibleTag('false')
    }
  }, [appointmentDetailModal])

  useEffect(() => {
    if (detailVisible) {
      setVisibleTags('true')
    } else {
      setVisibleTags('false')
    }
  }, [detailVisible])

  const getPage = () => {
    dispatch(
      appointmentListAsync({
        ...params,
        startTime: params?._dateRange == 7 ? undefined : (params?.startTime || head),
        endTime: params?._dateRange == 7 ? undefined : (params?.endTime || tail),
        actionTimeHead: undefined,
        actionTimeTail: undefined,
        patientId,
        name: toothPatient ? name : params?.name
        // onlyDisplayThisAccount: onlyThisAccount || false,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        const data = {
          items: v?.records,
          size: v?.size,
          total: v?.total,
          current: v?.current,
        }
        setPage(data)
        dispatch(setBtnLoading(false))
      })
  }

  useEffect(() => {
    dispatch(setBtnLoading(true))
    if (params.current !== 0) {
      getPage()
      getPageColumnList()
      sessionStorage.setItem(
        location.pathname + '_yuyue',
        JSON.stringify({ ...params, tabBar: '4' })
      )
    }
  }, [params])

  // useImperativeHandle(ref, () => ({
  //   reload: () => {
  //     dispatch(getPaymentList(params))
  //   },
  // }))

  // 获取预约查看患者手机号数据权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.YYCKHZSJH }))
      .then(unwrapResult)
      .then((res: any) => {
        setYYCKHZSJHData(res)
      })
    // 获取预约查看患者身份证号数据权限
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.YYCKHZSFZH }))
      .then(unwrapResult)
      .then((res: any) => {
        setYYCKHZSFZHData(res)
      })
  }

  useEffect(() => {
    if (activeKey == '4') {
      getCheckPermissionFn()
    }
  }, [activeKey])

  // 使用首页传入的权限或预约自己的权限
  const phonePermission = SYCKHRSJHData !== undefined ? SYCKHRSJHData : YYCKHZSJHData
  const idCardPermission = SYCKHZSFZHData !== undefined ? SYCKHZSFZHData : YYCKHZSFZHData

  return (
    <Col
      className={toothPatient ? styles.mainNoPadding : styles.main}
      style={{
        marginTop: patientId || toothPatient ? 0 : type == 1 ? '0' : '10px',
        height: type == 1 || patientId ? '100%' : 'calc(100% - 20px)',
        paddingLeft: type == 1 ? 10 : 15,
      }}
    >
      <Query
        filterFlag={!patientId && activeKey != '12'}
        toothPatient={toothPatient}
        onValueChange={(v) => {
          setParams({
            ...params,
            ...v,
            current: 1,
            endTime: v.actionTimeTail,
            startTime: v.actionTimeHead,
          })

          onLeftCount &&
            onLeftCount({
              //口腔版 his 左侧统计数据
              departmentIdA: v.departmentId,
              doctorIdA: v.mainDoctorId,
              nameA: v.name,
              startTimeA: v.actionTimeHead ? v.actionTimeHead : v.startTime,
              endTimeA: v.actionTimeTail ? v.actionTimeTail : v.endTime,
              appointmentStateA: v.appointmentState,
              appointmentTypeA: v.appointmentType,
            })
        }}
        patientId={patientId}
        type={type || 0}
        filterColumn={allColumnList} //筛选列
        filterSelectList={filterSelectList}
        // 筛选列变化时的数据
        submitPageList={(v: any) => {
          dispatch(setBtnLoading(true))
          submitPageList(v)
          setAllColumnList(v)
        }}
      />
      <SimpleAgGrid
        page={{
          current: params?.current,
          size: params?.size,
          total: page?.total,
          items: page?.items,
        }}
        column={(column(
          params?.size * (params?.current - 1),
          (action: any, t: any) => {
            switch (action) {
              case 'apply':
                if (hisVersion == 1) {
                  setTableEditId(t.id)
                  setTableEditPatientId(t.patientId)
                  setRegisteredModal(true)
                } else {
                  dispatch(
                    traceRoute({
                      name: '挂号',
                      path: '/registration',
                    })
                  )
                  localStorage.setItem('appointFlag', 'appointState')
                  dispatch(setAppointmentIdSlice(t.id))
                }
                break
              case 'detail':
                if (hisVersion == 1) {
                  setTableEditId(t.id)
                  setDetailVisible(true)
                } else {
                  history.push({
                    pathname: '/appointmentDetail',
                    state: {
                      id: t.id,
                      appointmentState: t.appointmentState,
                      tag: '0', //专业版标志位
                    },
                  })
                }

                // dispatch(
                //   traceRoute({
                //     name: "预约详情",
                //     path: "/appointmentDetail",
                //     state: {
                //       id: t.id,
                //     },
                //   })
                // )
                break
              case 'edit':
                if (hisVersion == 1) {
                  setTableEditId(t.id)
                  setToothEditAppointmentMoal(true)
                } else {
                  history.push({
                    pathname: '/addEditAppointment',
                    state: {
                      id: t.id,
                    },
                  })
                }
                break
              case 'cancel':
                dispatch(cancelAppointmentAsync({ id: t.id, sendSMSFlag: t.sendSMSFlag }))
                  .then(unwrapResult)
                  .then(() => {
                    getPage()
                  })
                break
              case 'sure':
                setSureData(t)
                setSureVisible(true)
                setChecked(false)
                break
              case 'sendSms':
                dispatch(sendAppointmentSmsAsync({ id: t.id }))
                  .then(unwrapResult)
                  .then(() => {
                    message.success('短信已发送')
                    getPage()
                  })
                  .catch((e: any) => {
                    if (e?.message && e.message.includes('短信次数已用完')) {
                      Modal.confirm({
                        centered: true,
                        title: '提示',
                        content: e.message,
                        cancelText: '取消',
                        okText: '去充值',
                        onOk: () => {
                          setSmsRechargeVisible(true)
                        },
                      })
                    } else {
                      message.error('短信发送失败')
                    }
                  })
                break
              default:
                break
            }
          },
          type,
          allColumnList,
          !patientId && activeKey != '12',
          phonePermission
        ))?.filter((item: any) => filterSelectList?.includes(item.field))}
        isLoading={pageLoading}
        pagination={true}
        pageKey={'appointmentList'}
        rowSelection="multiple"
        onRowDoubleClick={(event: any) => {
          const r = event?.data || {}
          setDetailId(r?.id)
          if (hisVersion == 1) {
            setAppointmentDetailModal(true)
          } else {
            dispatch(
              traceRoute({
                name: '预约详情',
                path: '/appointmentDetail',
                state: {
                  id: r.id,
                  appointmentState: r.appointmentState,
                  tag: '0', //专业版标志位
                },
              })
            )
          }
        }}
        suppressRowClickSelection={true}
        // 配置底部行样式
        getRowStyle={(params) => {
          if (params.node.rowPinned) {
            return {
              fontWeight: 'normal',
              backgroundColor: '#D9F2FF',
            };
          }
          return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
        }}
        onChangePage={(current, size) => {
          setParams({
            ...params,
            current,
            size,
          })
        }}
        onColumnResized={(v) => {
          return
        }}
        onColumnMoved={(v) => {
          // setPageLoading(true)
          const sortList = getSortColumnList(allColumnList, v);
          submitPageList(sortList)
          setAllColumnList(sortList)
        }}
      />
      {/* <EditableList
        loading={pageLoading}
        bordered={type == 1 ? true : false}
        className={styles.table}
        rowKey={(v, i) => `${i}`}
        sticky={location.pathname == '/toothHome'}
        page={{
          current: params.current,
          size: params.size,
          total: page.total,
          items: page.items,
        }}
        columns={column(
          params.size * (params.current - 1),
          (action:any, t:any) => {
            switch (action) {
              case 'apply':
                if (hisVersion == 1) {
                  setTableEditId(t.id)
                  setTableEditPatientId(t.patientId)
                  setRegisteredModal(true)
                } else {
                  dispatch(
                    traceRoute({
                      name: '挂号',
                      path: '/registration',
                    })
                  )
                  localStorage.setItem('appointFlag','appointState') 
                  dispatch(setAppointmentIdSlice(t.id))
                }
                break
              case 'detail':
                if (hisVersion == 1) {
                  setTableEditId(t.id)
                  setDetailVisible(true)
                } else {
                  history.push({
                    pathname: '/appointmentDetail',
                    state: {
                      id: t.id,
                      appointmentState: t.appointmentState,
                      tag: '0', //专业版标志位
                    },
                  })
                }

                // dispatch(
                //   traceRoute({
                //     name: "预约详情",
                //     path: "/appointmentDetail",
                //     state: {
                //       id: t.id,
                //     },
                //   })
                // )
                break
              case 'edit':
                if (hisVersion == 1) {
                  setTableEditId(t.id)
                  setToothEditAppointmentMoal(true)
                } else {
                  history.push({
                    pathname: '/addEditAppointment',
                    state: {
                      id: t.id,
                    },
                  })
                }

                // dispatch(
                //   traceRoute({
                //     name: "修改预约",
                //     path: "/addEditAppointment",
                //     state: {
                //       id: t.id,
                //     },
                //   })
                // )
                break
              case 'cancel':
                dispatch(cancelAppointmentAsync({ id: t.id, sendSMSFlag: t.sendSMSFlag }))
                  .then(unwrapResult)
                  .then(() => {
                    getPage()
                  })
                break
              case 'sure':
                setSureData(t)
                setSureVisible(true)
                setChecked(false)
                break
              default:
                break
            }
          },
          type,
        ).filter((v:any) =>
          !patientId
            ? v
            : v.dataIndex != 'name' &&
              v.dataIndex != 'sex' &&
              v.dataIndex != 'name' &&
              v.dataIndex != 'ageYear' &&
              v.dataIndex != 'phone'
        )}
        onChangePage={(current, size) => {
          setParams({
            ...params,
            current,
            size: size || 10,
          })
        }}
        onRow={(r:any) => ({
          onDoubleClick: () => {
            setDetailId(r.id)
            if (hisVersion == 1) {
              setAppointmentDetailModal(true)
            } else {
              dispatch(
                traceRoute({
                  name: '预约详情',
                  path: '/appointmentDetail',
                  state: {
                    id: r.id,
                    appointmentState: r.appointmentState,
                    tag: '0', //专业版标志位
                  },
                })
              )
            }
          },
        })}
      /> */}
      <Modal
        title='预约详情'
        width={1050}
        visible={appointmentDetailModal}
        onCancel={() => {
          setAppointmentDetailModal(false)
        }}
        footer={null}
      >
        {/* <div> */}
        <AppointmentDetail id={detailId} visibleTag={visibleTag} />
        {/* </div> */}
      </Modal>
      <Modal
        title='失败原因'
        visible={reasonModal}
        onCancel={() => {
          setReasonModal(false)
          form.resetFields()
        }}
        footer={null}
      >
        {failReason}
        <Row justify='end'>
          <Button type='primary' onClick={() => setReasonModal(false)}>
            确认
          </Button>
        </Row>
      </Modal>

      {/* his 口腔版修改预约 */}
      <Modal
        title='修改预约'
        visible={toothEditAppointmentMoal}
        onCancel={() => {
          setToothEditAppointmentMoal(false)
        }}
        width={1200}
        footer={null}
        destroyOnClose
      >
        <div style={{ height: 600 }}>
          <AppointmentRegister
            phonePermission={phonePermission}
            idCardPermission={idCardPermission}
            AppointmentId={Number(tableEditId)}
            status={2}
            onsubmit={() => {
              setParams({
                ...params,
                current: 1,
              })
              setToothEditAppointmentMoal(false)
            }}
            onCancel={() => {
              setToothEditAppointmentMoal(false)
            }}
          />
        </div>
      </Modal>
      {/* 工作站-挂号 */}
      <RegisteredModal
        title={0}
        patientId={tableEditPatientId}
        appointmentId={tableEditId}
        visible={registeredModal}
        onOk={() => {
          setTableEditPatientId('');
          setTableEditId('');
          setRegisteredModal(false)
        }}
        onCancel={() => {
          setRegisteredModal(false)
        }}
      />

      <Modal
        width={1050}
        title='预约详情'
        destroyOnClose
        visible={detailVisible}
        onCancel={() => setDetailVisible(false)}
        footer={null}
      >
        <div>
          <AppointmentDetail
            id={tableEditId}
            status={String(hisVersion)}
            visibleTag={visibleTags}
          />
        </div>
      </Modal>

      <Modal
        width={500}
        title='确认操作'
        confirmLoading={loading}
        destroyOnClose
        visible={sureVisible}
        onCancel={() => setSureVisible(false)}
        onOk={() => {
          setLoading(true)
          dispatch(sureAppointmentAsync({ id: sureData?.id, flag: checked ? 1 : 0 }))
            .then(unwrapResult)
            .then(() => {
              setLoading(false)
              setSureVisible(false)
              getPage()
            })
        }}
      >
        <div style={{ paddingLeft: '10px' }}>
          <Checkbox checked={checked} onChange={() => {
            setChecked(!checked)
          }}>
            发送短信 {sureData?.tenantName && '-'} 您已成功预约
            请在{sureData?.appointmentDate}&nbsp;&nbsp;
            {sureData?.appointmentStartTime}
            {sureData?.appointmentStartTime && sureData?.appointmentEndTime ? '~' + sureData?.appointmentEndTime : ''}
            到挂号处登记信息。地址：{sureData?.tenantAddress || '-'} 电话：
            {sureData?.tenantPhone || '-'}
          </Checkbox>
          {/* {sureData?.smsSendFlg == 1 ? (<p>该预约已发送过短信</p>) : ''} */}
        </div>
      </Modal>
      <SmsRechargeModal
        visible={smsRechargeVisible}
        onCancel={() => setSmsRechargeVisible(false)}
      />
    </Col>
  )
}

export const AppointmentLists = forwardRef(AppointmentList)
